/**
 * 根据数字设置颜色
 * @param { number } num
 * @return { string }
 */
export const getWorldColor = function getWorldColor(num) {
    if (num >= 3000_0000) {
        return '#1c3f7d';
    } else if (num >= 1000_0000) {
        return '#155cb6';
    } else if (num >= 300_0000) {
        return '#2070cd';
    } else if (num >= 100_0000) {
        return '#4085dd';
    } else if (num >= 30_0000) {
        return '#3f89d9';
    } else if (num >= 10_0000) {
        return '#47a1f8';
    } else if (num >= 3_0000) {
        return '#5cb8fc';
    } else if (num >= 1_0000) {
        return '#64c9ff';
    } else if (num >= 3_000) {
        return '#efefef';
    } else {
        return '#fff';
    }
};

/* 转换接种数据 */
export const formatSumData = function formatSumData(data, noneDefaultData) {
    let unit = '';
    let num = data;

    if (data >= 1_0000_0000) {
        num = Number((data / 1_0000_0000).toFixed(1));
        unit = '亿';
    } else if (data >= 1_0000) {
        num = Number((data / 1_0000).toFixed(1));
        unit = '万';
    }

    return { unit, num: num || noneDefaultData || 0 };
};

export const classNames = function classNames(...name) {
    return name.join(' ');
};

// 判断是否是客户端
export const isClient = function isClient() {
    return typeof window === 'object' && typeof window.grounds !== 'undefined';
};
